export const isPromise = (object: any): boolean => {
    return object instanceof Promise
}

export const isEmpty = (obj: object): boolean => {
    return Object.keys(obj).length === 0 && obj.constructor === Object
}

export interface DateRange {
    from: Date
    to: Date
}

export const extractDateRangeFromUrl = (): DateRange => {
    // using vanilla JS here because useLocation() can't be used due to being hook
    // and we are not calling this inside of a function
    const urlParams = new URLSearchParams(window.location.search)
    const from = urlParams.get('from')
    const to = urlParams.get('to')

    if (from && to) {
        return {
            from: new Date(from),
            to: new Date(to),
        }
    }

    return {
        from: new Date(new Date().setDate(new Date().getDate() - 30)),
        to: new Date(),
    }
}

export const formatDateFromString = (date: string): Date => {
    const output = Date.parse(date)

    return new Date(output)
}

export const isDefined = (target: any, path: string): boolean => {
    if (typeof target != 'object' || target == null) {
        return false
    }

    const parts = path.split('.')

    while (parts.length) {
        const branch = parts.shift()
        if (!branch || !(branch in target)) {
            return false
        }

        target = target[branch]
    }

    return true
}

// returns days and hours diff between date1 and date2.
// note: date 1 should be the later date
export const timeDifference = (
    date1: number,
    date2: number,
): {
    daysDifference: number
    hoursDifference: number
} => {
    let difference = date1 - date2

    const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24)
    difference -= daysDifference * 1000 * 60 * 60 * 24

    const hoursDifference = Math.floor(difference / 1000 / 60 / 60)
    difference -= hoursDifference * 1000 * 60 * 60

    return {
        daysDifference,
        hoursDifference,
    }
}
